module.exports = __webpack_public_path__ + "img/icon6.dc564c56.svg";